import React, { useEffect } from 'react';
import Main from './Main';
import './App.scss';
import {
  ELECTION_PATH_NAME,
  LOCALSTORAGE_ELECTION_KEY,
  LOCALSTORAGE_ELECTION_YEARS,
  SESSION_PERSIST_KEY,
} from './Utility/constants';
/// more expresseing root name

function App() {
  useEffect(() => {
    if (window.location.pathname !== ELECTION_PATH_NAME) {
      localStorage.removeItem(`mvw-${LOCALSTORAGE_ELECTION_KEY}`);
      localStorage.removeItem(`mvw-${LOCALSTORAGE_ELECTION_YEARS}`);
      sessionStorage.removeItem(SESSION_PERSIST_KEY);
    }
  });
  return <Main />;
}

export default App;
